<template>
  <app-base-main parentTable no-padding>
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery">
        <gj-market-select
            v-model="filter.marketIds"
            multiple
            width="150px"
            placeholder="请选择店铺"
        ></gj-market-select>
        <gj-select
            v-model="filter.currency"
            :options="options.financeProfitReport"
            :clearable="false"
        ></gj-select>
        <gj-date-picker
            v-model="filter.dateVal"
            type="monthrange"
            :clearable="false"
            :shortcut="false"
        ></gj-date-picker>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button type="primary" @click="clickRecalculate">重算</gj-button>
      <div style="display: inline-block">
        <gj-text-alert type="info" iconColor="#999">
          注意：建议相关店铺使用谷歌浏览器安装积加云助手浏览器插件，实现数据每天自动同步，具体安装方式参考
          <gj-link href="http://help.gerpgo.com/web/#/26?page_id=633" target="_blank">帮助文档</gj-link>
          或联系客服
        </gj-text-alert>
      </div>
      <!-- <span class="attention">
        注意：建议相关店铺使用谷歌浏览器安装积加云助手浏览器插件，实现数据每天自动同步，具体安装方式参考
        <gj-link href="http://help.gerpgo.com/web/#/26?page_id=633" target="_blank">帮助文档</gj-link>
        或联系客服
      </span> -->
    </template>
    <template #tool-group>
      <profit-report-tool
          download-url="/finance/financialProfitAnalysis/exportProfitAnalysis"
          :download-params="globalExportParams"
      ></profit-report-tool>
    </template>
    <template #table>
      <gj-table
          :data="data"
          adaptParent
          :columns="columns"
          :tree-config="{children: 'children', expandAll: true}"
          :index="false"
          :loading="loading">
          <template v-slot:label="{ row }">
            {{ row.label }}
            <gj-help font-size="14px" v-if="row.tip">
              {{ row.tip }}
            </gj-help>
          </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import { financeCurrencysOption } from "@/utils/options";
  import {endOfMonth, startOfMonth, subMonths} from 'date-fns';
  import ProfitReportTool from "../tool/profit-report-tool";
  import FinanceRecalculate from "modules/common/finance/finance-recalculate-modal";
  import {queryMixin} from "@/minxins";
  import {convertToFullDate} from "@/utils/date.util";
  import {exportFinanceProfitReportMonth, getFinanceProfitReportMonth} from "@/api/finance";

  export default {
    name: "finance-profit-report-month",
    components: {ProfitReportTool},
    mixins: [queryMixin],
    data() {
      return {
        columns: [
          {id: 'label', header: '项目', field: 'slot:label', minWidth: '130px'},
          {
            id: 'bb', header: '期间', align: 'center', children: [
              {id: 'total', header: '合计', field: 'total', align: 'right', minWidth: '120px', prefix: 'currencySymbol'}
            ]
          },
        ],
        data: [],
        filter: {
          marketIds: [],
          currency: '',
          dateVal: [startOfMonth(subMonths(new Date(), 7)), endOfMonth(subMonths(new Date(), 1))],
        },
        useCache: false,
        notStorage: true,
        globalExportParams: null
      }
    },
    methods: {
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{ marketIds: *}}
       */
      $gjCacheCallback(params) {
        return {
          marketIds: params.marketIds
        };
      },
      $gjQuery() {
        this.loading = true;
        this.data = [];
        this.globalParams = {
          currency: this.filter.currency,
          marketIds: this.filter.marketIds,
          startDate: convertToFullDate(this.filter.dateVal[0], 'yyyy-MM') + '-01',
          endDate: convertToFullDate(this.filter.dateVal[1], 'yyyy-MM') + '-01',
        };
        this.globalExportParams={
          model:{
             currency: this.filter.currency,
            marketIds: this.filter.marketIds,
            startDate: convertToFullDate(this.filter.dateVal[0], 'yyyy-MM') + '-01',
            endDate: convertToFullDate(this.filter.dateVal[1], 'yyyy-MM') + '-01',
            queryType:'monthly'
          }
        }
        getFinanceProfitReportMonth(this.globalParams).then((result) => {
          this.data = [];
          this.columns[1].children = [{
            id: 'total',
            header: '合计',
            field: 'total',
            align: 'right',
            minWidth: '120px',
            prefix: 'currencySymbol'
          }];
          if (result && result.data.length > 0) {
            result.data.forEach(v => {
              this.recursionChild(v.children);
              this.data.push({...v, ...v.map});
            });
            this.columns[1].id = `${this.globalParams.startDate}~${this.globalParams.endDate}`;
            this.columns[1].children.push(...this.initCol(result.date));
            // 关于这一句的作用，有机会问提交人吧，先不要删
            this.data = [...this.data];
          }
        }).complete(() => this.loading = false)
      },
      recursionChild(list) {
        return list.forEach(v => {
          if (v.children && v.children.length > 0) {
            this.recursionChild(v.children);
          }
          for (let key in v.map) {
            v[key] = v.map[key];
          }
        })
      },
      initCol(list) {
        return list.map(v => {
          return {
            id: v,
            header: v,
            field: v,
            align: 'right',
            minWidth: '120px',
            checked: true,
            prefix: 'currencySymbol'
          };
        })
      },
      clickRecalculate() {
        this.$gjCreate(FinanceRecalculate)
      },
      download() {
        exportFinanceProfitReportMonth(this.globalParams)
      }
    },
    computed: {
      // 币种
      options() {
        let financeProfitReport = this._.cloneDeep(financeCurrencysOption)
        financeProfitReport.shift()
        return { financeProfitReport }
      },
    },
    created() {
      this.filter.currency = "USD"
      this.$gjNoticeQuery()
    }
  }
</script>

<style lang="scss" scoped>
  @import 'common';
</style>
